import React from 'react'
import { STORAGE_KEYS } from '../lib/constants'
import { reportError } from '../lib/reporting'
import { getItem, setItem } from '../lib/storage'

const asError = (error: unknown) => (error instanceof Error ? error : new Error(String(error)))

/**
 * In-game tips minimized to their title row (still enabled — Disable turns
 * them off). Remembered per device, so a player who minimizes them keeps
 * the compact row across phases and games.
 */
export function useTutorialTipsCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = React.useState(false)
  React.useEffect(() => {
    let active = true
    getItem(STORAGE_KEYS.TUTORIAL_TIPS_COLLAPSED)
      .then((stored) => { if (active) setCollapsed(stored === 'true') })
      .catch((error: unknown) => {
        reportError(asError(error), { tags: { area: 'tutorial-tips', action: 'load-preference' } })
      })
    return () => { active = false }
  }, [])
  const toggle = React.useCallback(() => {
    const next = !collapsed
    setCollapsed(next)
    setItem(STORAGE_KEYS.TUTORIAL_TIPS_COLLAPSED, String(next)).catch((error: unknown) => {
      reportError(asError(error), { tags: { area: 'tutorial-tips', action: 'save-preference' } })
    })
  }, [collapsed])
  return [collapsed, toggle]
}
